import React, { useRef, useState, useEffect } from 'react';
import { Box, Stack, Image, IconButton } from '@chakra-ui/react';

const images = [
  '/assets/images/carrussel_01.png',
  '/assets/images/carrussel_02.png'
];

const Carrousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const scroller = useRef(null);
  const intervalRef = useRef(null);
  const [miliseconds, setMiliseconds] = useState(10000);
  const loopedImages = [...images, images[0]];

  const scrollToIndex = (index, smooth = true) => {
    const containerWidth = scroller.current.clientWidth;
    scroller.current.style.scrollBehavior = smooth ? 'smooth' : 'auto';
    scroller.current.scrollLeft = containerWidth * index;
  };

  const scrollToNext = () => {
    setCurrentIndex((prevIndex) => {
      const nextIndex = (prevIndex + 1) % loopedImages.length;
      scrollToIndex(nextIndex, prevIndex + 1 < loopedImages.length);
      setMiliseconds(prevIndex === 0 ? 10000 : 5000);
      return nextIndex;
    });
  };

  useEffect(() => {
    intervalRef.current = setInterval(scrollToNext, miliseconds); 

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [currentIndex]);


  return (
    <Box position="relative" overflow="hidden" maxWidth="container.md" margin="auto">
      {/* ... */}
      <Stack
        direction="row"
        spacing={0}
        ref={scroller}
        sx={{
          scrollSnapType: 'x mandatory',
          overflowX: 'scroll',
          '&::-webkit-scrollbar': { display: 'none' },
          '& > *': { scrollSnapAlign: 'start', flex: 'none', width: '100%' },
          
        }}
      >
        {loopedImages.map((src, index) => (
          <Box key={index} boxSize="full" flex="none" p={0} m={0}>
            <Image src={src} alt={`Image ${index}`} boxSize="full" width="100%"  objectFit="cover"/>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default Carrousel;
